/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Tool_Discount_UseInputs */

const en_directory_tool_discount_use = /** @type {(inputs: Directory_Tool_Discount_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use code`)
};

const zh_directory_tool_discount_use = /** @type {(inputs: Directory_Tool_Discount_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用优惠码`)
};

/**
* | output |
* | --- |
* | "Use code" |
*
* @param {Directory_Tool_Discount_UseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tool_discount_use = /** @type {((inputs?: Directory_Tool_Discount_UseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tool_Discount_UseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tool_discount_use(inputs)
	return zh_directory_tool_discount_use(inputs)
});
export { directory_tool_discount_use as "directory.tool.discount_use" }